/**
 * Initialize ProductCarousel
 *
 * @class ProductCarousel
 */

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

class ProductCarousel {

  constructor(elem, params = {}) {
    if (!elem) {
      return;
    }

    this.elem = elem;
    this.parent = elem.closest('.m-product-carousel');

    // How many products to show in desktop
    this.productsPerView = this.elem.getAttribute('data-products-per-view') || params.productsPerView;
    this.productsPerView = this.productsPerView ? parseInt(this.productsPerView) : false;
    this.productsPerView = this.productsPerView && !isNaN(this.productsPerView) ? this.productsPerView : 5;

    if (typeof params.productsPerView !== 'undefined') {
      delete params.productsPerView;
    }

    const products = this.elem.getElementsByClassName('m-product-carousel__product');
    if (products.length < this.productsPerView) {
      this.productsPerView = products.length;
      this.elem.classList.add('m-product-carousel--item-count-'+products.length);
    }

    const defaultOptions = {
      effect: 'slide',
      simulateTouch: true,
      loop: false,
      speed: 500,
      navigation: true,
      slidesPerView: this.productsPerView < 2 ? this.productsPerView : 2,
      slidesPerGroup: this.productsPerView < 2 ? this.productsPerView : 2,
      breakpoints: {
        768: {
          slidesPerView: this.productsPerView,
          slidesPerGroup: this.productsPerView
        }
      }
    };

    const carouselOptions = defaultOptions;
    Object.keys(params).forEach((key, i) => {
      carouselOptions[key] = params[key];
    });

    // Arrow navigation
    if (carouselOptions.navigation) {

      // If more than 2 products, show arrows
      if (products.length > 2) {
        if (this.parent) {
          this.parent.classList.add('m-product-carousel--with-arrows');
        }

        // If this.productsPerView or less products, show arrows only in mobile
        if (products.length <= this.productsPerView && this.parent) {
          this.parent.classList.add('m-product-carousel--mobile-arrows');
        }

        // Add navigation
        const prev = document.createElement('button');
        prev.classList.add('swiper-button-prev', 'm-product-carousel__navigation', 'm-product-carousel__navigation--prev');

        const next = document.createElement('button');
        next.classList.add('swiper-button-next', 'm-product-carousel__navigation', 'm-product-carousel__navigation--next');

        this.elem.parentNode.appendChild(prev);
        this.elem.parentNode.appendChild(next);

        carouselOptions.navigation = {
          nextEl: next,
          prevEl: prev,
        };
      }
    }

    this.carousel = new Swiper(this.elem, carouselOptions);

    return this.carousel;
  }
}


export { ProductCarousel };
